import styled from 'styled-components'

export const Wrapper = styled.div`
  padding: 24px 16px 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 10px;
  border-top: 1px solid var(--color-border-subtle);
  flex-shrink: 0;
  margin-top: 24px;

  svg {
    width: 16px;
    height: 16px;
    color: var(--color-text-subtle);
    fill: var(--color-text-subtle);
  }
`

export const Tip = styled.p`
  font-size: var(--font-size-body-sm);
  color: var(--color-text-subtle);
  line-height: 16px;
  margin: 0;
  white-space: pre-wrap;
  padding: 0;

  span {
    font-weight: 700;
  }

  a {
    color: var(--color-text-brand);
    cursor: pointer;
    text-decoration: none;
    display: inline;
  }

  a:hover {
    text-decoration: underline;
  }
`
